var __rspack_ns_object = JSON.parse('{"Measurements":"Messungen","Studies":"Studien"}')